import toast from 'react-hot-toast';

function success(message) {
  toast.success(message, { position: 'top-right' });
}

function error(message) {
  toast.error(message, { position: 'top-right' });
}

function info(message) {
  toast(message, { position: 'top-right' });
}

const toastApi = { success, error, info };

export { success, error, info };
export default toastApi;
